import actionTypes from '../actionTypes';

export const GET_INVITE = actionTypes('GET_INVITE');
export const ACCEPT_INVITE = actionTypes('ACCEPT_INVITE');
export const CLEAR_INVITE = 'CLEAR_INVITE';
